import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-55add52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  name: "first",
  lazy: true,
  class: "",
  style: {"height":"100%"}
}
const _hoisted_2 = { style: {"height":"100%"} }
const _hoisted_3 = ["infinite-scroll-disabled"]
const _hoisted_4 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_5 = { class: "skeleton" }
const _hoisted_6 = { class: "skeletonItemWrapper" }
const _hoisted_7 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_8 = { class: "hoverContact" }
const _hoisted_9 = ["element-loading-text"]
const _hoisted_10 = {
  key: 0,
  class: "noMore"
}
const _hoisted_11 = {
  key: 2,
  class: "empty"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "empty-text" }

import { ref, onMounted, nextTick, computed, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import contactItem from "@/components/message/contactItem.vue";
import { useI18n } from "vue-i18n";
import { getChatSessionsApi } from "@/api/devices/index";
import emitter from "@/utils/eventBus";
import moment from "moment";
import { getQueryParam, gaEvent } from "@/utils/format";
import { ElMessage } from "element-plus";
import { contactDemoRes } from "@/components/chat/config/chatConfig";
import { event } from "vue-gtag";
import { jsonData } from '@/mock/message.js'


type contactType = {
  name: string;
  last_message: string;
  date: string;
  key: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'leftNoTabs',
  props: {
  accessTime: {
    type: Array,
  },
  isSync: {
    type: Boolean
  }
},
  emits: ['sendlastTime'],
  setup(__props, { emit: __emit }) {

const props = __props;
const Emits = __emit
const store = useStore();
const { t } = useI18n();
const isDemoRef = computed(() => store.state.isDemo);


const deviceId = computed(() => store.state.currentDeviceInfo.id);

const currentMonitorApp = computed(() => store.state.currentMonitorApp);
const isVibe = computed(() => !store.state.isVibe);
const isFirst = ref(false)//是否第一次进入到页面

// ==========leftChat============
const leftChatActive = ref(0);
const contactItemClick = (index: any, item: any) => {
  // console.log(item.chat_session_id)
  leftChatActive.value = index;
  store.commit("setClickItemKey", item.chat_session_id);
  store.commit("setSessionClickItem", item);
  store.commit("setIsShowMessageLeft", false);
  // store.commit('setIsClick', true)
};


// Tab1：联系人列表的全部内容
const contactList = ref<contactType[]>([]);
let cumulativeContactList: contactType[] = [];
const contactPageNum = ref(1); // 页码
let contactPageSize = ref(20); // 一页多少条数据
let noMoreContact = ref(false); // 是否展示没有更多数据文案
let contactGlobalLoading = ref(true);
const contactLoading = ref(false);
const disabledContactScroll = computed(
  () => contactLoading.value || noMoreContact.value
);
const lastUpdateTime = ref(0)//最后更新时间
// 获取左侧联系人列表
watch(deviceId, async () => {
  contactList.value = [];
  cumulativeContactList = []
  noMoreContact.value = false
  leftChatActive.value = 0
  contactPageNum.value = 1
  store.commit("setClickItemKey", null);
  store.commit("setSessionClickItem", null);
  console.log("setSessionClickItem现在置空了");
  await getContactList(false)
  gaEvent("Message_PV", {
    event_category: "Message",
    event_label: contactList.value.length > 0 ? 'Data' : 'NoData',
  });
})
// watch(() => props.isSync, () => {
watch(() => [props.accessTime, props.isSync], (newValue, oldValue) => {
  console.log("监听到了:", props);
  console.log("newValue:", newValue, oldValue);
  if (newValue[1]) {
    contactList.value = [];
    cumulativeContactList = []
    leftChatActive.value = 0
    contactPageNum.value = 1
    getContactList(false, true)
    store.commit("setClickItemKey", null);
    store.commit("setSessionClickItem", null);
    console.log("状态同步成功");
    clearInterval(closeFiveM);
    setNewInterval()
  } else if (newValue[0] != oldValue[0]) {
    contactList.value = [];
    cumulativeContactList = []
    leftChatActive.value = 0
    contactPageNum.value = 1
    console.log("newValue:", newValue[0], oldValue[0]);
    getContactList(false)
    store.commit("setClickItemKey", null);
    store.commit("setSessionClickItem", null);
    console.log("时间同步成功:");
    clearInterval(closeFiveM);
    setNewInterval()
  }

  // contactGlobalLoading.value = false;

}, {
  deep: true
})
// 五分钟定时更新
let closeFiveM: any
// 设置新的定时器
const setNewInterval = () => {
  clearInterval(closeFiveM);
  closeFiveM = setInterval(() => {
    contactPageNum.value = 1
    contactList.value = [];
    leftChatActive.value = 0
    cumulativeContactList = []
    store.commit("setClickItemKey", null);
    store.commit("setSessionClickItem", null);
    console.log("2222222222222");
    getContactList()
  }, 1000 * 60 * 5);
}
// isFromScroll是否是无限滚动触底时触发的
const getContactList = async (isFromScroll: boolean = false, isSync?: boolean) => {
  // 调用接口获取聊天记录,获取一页的数据
  // console.log(isFromScroll, 'isFromScroll');
  console.log('isFromScroll:', props.accessTime![0]);
  // contactGlobalLoading.value = true;
  try {
    let onePageContactList: any = [];
    let params
    console.log("isVibe:", isVibe.value);

    if (isVibe.value) {
      contactList.value = []
      store.commit("setSessionClickItem", null);
      console.log("store.state.sessionClickItem?.unique_id:", store.state.sessionClickItem?.unique_id, contactList.value[0]);
      contactPageNum.value = 1
      cumulativeContactList = []
      noMoreContact.value = false
      // await getContactList()
      lastUpdateTime.value = jsonData.data.update_time
      console.log("clickItemKey0:", store.state.clickItemKey);

      Emits('sendlastTime', lastUpdateTime.value)
      console.log("res.data.data:", jsonData.data);

      cumulativeContactList = jsonData.data.chat_sessions;

      contactList.value = cumulativeContactList;
      console.log("contactList.value:", contactList.value);

      store.commit("setClickItemKey", (contactList.value[0] as any).chat_session_id);
      setTimeout(() => {
        store.commit("setSessionClickItem", contactList.value[0]);
      })
      console.log("store.state.sessionClickItem?.unique_id:", store.state.sessionClickItem?.unique_id, contactList.value[0]);
      console.log("是否不是第一次进入1111：", isFirst.value);
      if (isFirst.value) {
        contactGlobalLoading.value = false;
        return
      }
      gaEvent("Message_PV", {
        event_category: "Message",
        event_label: contactList.value.length > 0 ? 'Data' : 'NoData',
      });
      isFirst.value = true
      console.log("res.data.data111111111111:");
      contactGlobalLoading.value = false;
      return
    } else {
      console.log("23232323");

      params = {
        device_id: deviceId.value,
        app: 'native',
        page: contactPageNum.value,
        page_size: contactPageSize.value,
        start: props.accessTime![0],
        // start: 0,
        end: props.accessTime![1],
        // end: end,
      };
    }

    let res: any;
    // console.log('getContactList执行');
    const chatListSourceRef = computed(() => store.state.chatListSource);
    // 取消掉上一次请求
    chatListSourceRef.value &&
      chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    res = await getChatSessionsApi(params);
    if (res.data.code == 200) {
      console.log("lastUpdateTime:", lastUpdateTime.value);
      if (isSync) {
        cumulativeContactList = []
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        gaEvent("Message_Sync", {
          event_category: "Message",
          event_label: "Success",
        });
      }
      console.log("clickItemKey:", store.state.clickItemKey);

      lastUpdateTime.value = res.data.data.update_time
      console.log("clickItemKey0:", store.state.clickItemKey);

      Emits('sendlastTime', lastUpdateTime.value)
      console.log("res.data.data:", res.data.data);

      // if (!res.data.data.chat_sessions) {
      if (res.data.data.total == 0) {
        // 如果左侧会话列表数据为空
        contactList.value = [];
        contactGlobalLoading.value = false;
        store.commit("setClickItemKey", null);
        store.commit("setSessionClickItem", null);
        if (isFirst.value) return
        gaEvent("Message_PV", {
          event_category: "Message",
          event_label: contactList.value.length > 0 ? 'Data' : 'NoData',
        });
        isFirst.value = true
        return;
      }
      onePageContactList = res.data.data.chat_sessions || [];

      cumulativeContactList = cumulativeContactList.concat(onePageContactList);

      contactList.value = cumulativeContactList;

      store.commit("setClickItemKey", (contactList.value[0] as any).chat_session_id);

      store.commit("setSessionClickItem", contactList.value[0]);

      console.log("是否不是第一次进入：", isFirst.value);
      if (isFirst.value) {
        return new Promise((resolve, reject) => {
          // resolve(onePageContactList)
          resolve(res.data.data);
        });
        return
      }
      gaEvent("Message_PV", {
        event_category: "Message",
        event_label: contactList.value.length > 0 ? 'Data' : 'NoData',
      });
      isFirst.value = true
      console.log("res.data.data111111111111:", res.data.data);
      // return res.data.data
      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }
  } catch (err) {
    console.log(err);
    // emitter.emit('closeLoading')
    emitter.emit("closeChatLoading");
    if (isSync) {
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
      gaEvent("Message_Sync", {
        event_category: "Message",
        event_label: "Fail",
      });
    }
  } finally {
    contactGlobalLoading.value = false;
    setTimeout(() => {
      store.commit("setSyncLoading", false);
      contactLoading.value = false;
    })
    // emitter.emit('closeChatLoading')
  }
  // }
};
onMounted(async () => {

  // 首次渲染页面时，将列表中的第一项数据放进clickMailItemDetail
  contactGlobalLoading.value = true;
  if (isVibe.value) {
    contactList.value = []
    contactPageNum.value = 1
    cumulativeContactList = []
    noMoreContact.value = false
    await getContactList()
  }


});

const loadMoreContactList = () => {
  console.log("再调多一次");
  if (isVibe.value) return
  contactLoading.value = true;
  setTimeout(async () => {
    // console.log("loadMoreContactList");
    contactPageNum.value++;
    let res: any = await getContactList(true);
    console.log("res:", res);
    const total = res.total;
    // contactLoading.value = false;
    console.log("contactList.value.length:", contactList.value.length, total);

    if (contactList.value.length >= total) {
      // 如果当前列表总长度大于等于接口返回的数据总长度，则显示没有更多数据文案
      noMoreContact.value = true;
      console.log("没有下一页了");

    }

  }, 100);
};
onUnmounted(() => {
  clearInterval(closeFiveM);
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["leftTabs", contactList.value.length > 0 ? '' : 'isNoData'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          "infinite-scroll-immediate": false,
          "infinite-scroll-disabled": disabledContactScroll.value,
          "infinite-scroll-distance": "1",
          style: {"height":"100%"},
          class: "leftList"
        }, [
          (_unref(contactGlobalLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_el_skeleton, {
                  style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                  loading: _unref(contactGlobalLoading),
                  animated: true,
                  count: 9
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "circle",
                        style: {"margin-right":"12px"}
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"40%"}
                        }),
                        _createVNode(_component_el_skeleton_item, {
                          variant: "text",
                          style: {"width":"85%"}
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : _createCommentVNode("", true),
          (contactList.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactList.value, (item, index) => {
                    return (_openBlock(), _createBlock(contactItem, {
                      key: index,
                      item: item,
                      onClick: ($event: any) => (contactItemClick(index, item)),
                      class: _normalizeClass([leftChatActive.value == index ? 'active' : ''])
                    }, null, 8, ["item", "onClick", "class"]))
                  }), 128))
                ]),
                _withDirectives(_createElementVNode("div", {
                  "element-loading-text": _ctx.$t('chat.loadingText'),
                  style: _normalizeStyle({ 'margin-top': contactLoading.value ? '40px' : '10px' })
                }, null, 12, _hoisted_9), [
                  [_directive_loading, contactLoading.value]
                ]),
                (_unref(noMoreContact))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                  : _createCommentVNode("", true)
              ]))
            : (!_unref(contactGlobalLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                ]))
              : _createCommentVNode("", true)
        ], 8, _hoisted_3)), [
          [_directive_infinite_scroll, loadMoreContactList]
        ])
      ])
    ])
  ], 2))
}
}

})